/**
 * Текст сообщения чата из значения любой формы.
 *
 * Колонка chat_messages.message — JSON, поэтому backend отдаёт не только строку:
 * сообщение «123» приходит числом, а системные сообщения — объектом
 * {type: 'text', text: '...'}. Плюс часть старых сообщений лежит строкой с JSON внутри.
 *
 * JSON.parse разбирает и голые скаляры («123» -> 123), поэтому строку разбираем
 * только если она похожа на конверт: иначе обычный текст превращался бы в пустоту.
 */
export const getMessageText = (value) => {
  if (value == null) return ''

  if (typeof value === 'string') {
    const trimmed = value.trim()
    const looksLikeEnvelope =
      (trimmed.startsWith('{') && trimmed.endsWith('}')) ||
      (trimmed.startsWith('[') && trimmed.endsWith(']')) ||
      (trimmed.startsWith('"') && trimmed.endsWith('"'))

    if (!looksLikeEnvelope) return value

    try {
      const parsed = JSON.parse(trimmed)
      if (typeof parsed === 'string' || (parsed && typeof parsed === 'object')) {
        return getMessageText(parsed)
      }
      return value
    } catch (error) {
      return value
    }
  }

  if (Array.isArray(value)) return value.map(getMessageText).filter(Boolean).join('\n')

  if (typeof value === 'object') {
    return getMessageText(value.text ?? value.message ?? value.content ?? value.value ?? '')
  }

  return String(value)
}
